import endpoints from "../config/endpoints";
import api from "../config/axios";

export const loginUser = async (email, password) => {
  try {
    const response = await api.post(endpoints.User.UserLogin, { email, password });

    return {
      status: response.data.status,
      statusCode: response.data.statusCode,
      message: response.data.message,
      data: response.data.data
    };
  } catch (err) {
    return {
      status: false,
      statusCode: 500,
      message: err.response?.data?.message || "Something went wrong",
      data: null
    };
  }
};

export const loginAdmin = loginUser; // alias for backward compatibility

export const GetUserById = async (userId) => {
  try {
    const response = await api.get(`${endpoints.User.GetUserDetailsById}?id=${userId}`);
    return {
      data: response.data.data || null,
      status: response.data.status,
      statusCode: response.data.statusCode,
      message: response.data.message,
    };
  } catch (error) {
    console.error('Error fetching user details:', error);
    return {
      data: null,
      status: false,
      statusCode: 500,
      message: 'Error fetching user details',
    };
  }
};

export const forgotPassword = async (email) => {
  try {
    const response = await api.post(endpoints.User.ForgotPassword, { email });
    return {
      data: response.data.data || null,
      status: response.data.status,
      statusCode: response.data.statusCode,
      message: response.data.message,
    };
  } catch (error) {
    console.error('Error during forgot password:', error);
    return {
      data: null,
      status: false,
      statusCode: 500,
      message: error.response?.data?.message || 'Error processing forgot password request.',
    };
  }
};

export const updateUserDetails = async (userId, userData) => {
  try {
    const response = await api.put(`${endpoints.User.UpdateUserDetails}/${userId}`, userData);
    return {
      data: response.data.data || null,
      status: response.data.status,
      statusCode: response.data.statusCode,
      message: response.data.message,
    };
  } catch (error) {
    console.error('Error updating user details:', error);
    return {
      data: null,
      status: false,
      statusCode: 500,
      message: 'Error updating user details',
    };
  }
};

export const RegisterUser = async (userDTO) => {
  try {
    const response = await api.post(endpoints.User.Registration, userDTO);
    return {
      data: response.data.data || null,
      status: response.data.status,
      statusCode: response.data.statusCode,
      message: response.data.message,
    };
  } catch (error) {
    console.error('Error registering user:', error);
    return {
      data: null,
      status: false,
      statusCode: 500,
      message: error.response?.data?.message || 'Error registering user',
    };
  }
};

export const SearchUserByPhone = async (phone) => {
  try {
    const response = await api.get(`${endpoints.User.GetAllUsers}?phone=${encodeURIComponent(phone)}`);
    return {
      data: response.data.data || [],
      status: response.data.status,
      statusCode: response.data.statusCode,
      message: response.data.message,
    };
  } catch (error) {
    console.error('Error searching user by phone:', error);
    return {
      data: [],
      status: false,
      statusCode: 500,
      message: 'Error searching user by phone',
    };
  }
};

export const GetCustomers = async (params) => {
  try {
    const query = new URLSearchParams(params).toString();
    const response = await api.get(`${endpoints.User.GetAllUsers}?${query}`);
    return {
      data: response.data.data || [],
      status: response.data.status,
      statusCode: response.data.statusCode,
      message: response.data.message,
    };
  } catch (error) {
    console.error('Error fetching customers:', error);
    return {
      data: [],
      status: false,
      statusCode: 500,
      message: 'Error fetching customers',
    };
  }
};

const userService = {
  loginUser,
  loginAdmin,
  GetUserById,
  forgotPassword,
  updateUserDetails,
  RegisterUser,
  SearchUserByPhone,
  GetCustomers
};

export default userService;
